import * as React from 'react';
import xlsxIcon from '../../../../../assets/xlsxIcon';
import pdfIcon from '../../../../../assets/pdfIcon';
import SlideMenu from 'src/components/common/SlideMenu/SlideMenu';
import { downloadFile } from 'src/utils/downloadHelper';
import './ECheckPaymentDetailsMobile.scss';
import ECheckPaymentDetailsTableMobile from '../ECheckPaymentDetailsTableMobile';
import LocaleFormating from 'src/translation/localeFormating';
import i18n from 'src/translation/i18n';
import paySimpleServiceInstance from 'src/services/paySimple/paySimpleService';
interface IECheckPaymentDetailsMobileProps {
  showSlideMenu: boolean;
  onCloseSlide: () => void;
  paymentDetails: any;
  updatePayment: (databaseId: number, params: any) => void;
}

interface IECheckPaymentDetailsMobileState {
  taker: string;
  note: string;
  showLoader: boolean;
}

class ECheckPaymentDetailsMobile extends React.Component<
  IECheckPaymentDetailsMobileProps,
  IECheckPaymentDetailsMobileState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      taker: '',
      note: '',
      showLoader: false
    };
  }

  public componentDidMount() {
    this.forceUpdate();
  }

  private handleChangeTaker = (e: any) => {
    this.setState({
      taker: e.target.value
    });
  };

  private handleChangeNote = (e: any) => {
    this.setState({
      note: e.target.value
    });
  };

  private submitDisposition = () => {
    const { paymentDetails } = this.props;
    this.props.updatePayment(paymentDetails.databaseId, {
      disposition: 'AD',
      taker: this.state.taker,
      note: this.state.note
    });

    this.props.onCloseSlide();
  };
  public printPdfEcheck = () => {
    this.doExport('pdf');
  };
  public printExcelEcheck = () => {
    this.doExport('xlsx');
  };
  public doExport = (type: string) => {
    const { paymentDetails } = this.props;
    if (type === 'pdf') {
      this.setState({ showLoader: true });
      paySimpleServiceInstance
        .exportSelectedecheckSummary(
          type,
          paymentDetails.paymentNumber,
          0,
          0,
          'admin'
        )
        .then((response: any) => {
          this.setState({ showLoader: false });
          downloadFile(response.data, `Payment_Summary.pdf`);
        })
        .catch(error => {
          this.setState({ showLoader: false });
          console.log(error);
        });
    } else if (type === 'xlsx') {
      this.setState({ showLoader: true });
      paySimpleServiceInstance
        .exportSelectedecheckSummary(
          type,
          paymentDetails.paymentNumber,
          0,
          0,
          'admin'
        )
        .then((response: any) => {
          this.setState({ showLoader: false });
          downloadFile(response.data, `Payment_Summary.xlsx`);
        })
        .catch(error => {
          this.setState({ showLoader: false });
          console.log(error);
        });
    }
  };

  public render() {
    const { paymentDetails } = this.props;

    return (
      <SlideMenu
        mounted={this.props.showSlideMenu}
        goBackTitle={i18n.t('common.back')}
        level={2 + 30}
        handleCloseMenu={this.props.onCloseSlide}
      >
        <div className="rp-echeck-payment-details-mobile">
          <div className="row">
            <div className="col-12">
              <h2 className="rp-pay-detail-mobile-title">Payment Detail</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <h4 className="rp-pay-mobile-field--medium">Payment Id:</h4>
            </div>
          </div>
          <div className="row rp-pay-mobile-margin-bottom">
            <div className="col-12">
              <span className="rp-pay-color-blue">
                {paymentDetails.paymentNumber}
              </span>
            </div>
          </div>
          <div className="row rp-pay-mobile-field-container">
            <div className="col-4">
              <h4 className="rp-pay-mobile-field">Cust code:</h4>
            </div>
            <div className="col-8">
              <span>{paymentDetails.customerCode}</span>
            </div>
          </div>
          <div className="row rp-pay-mobile-field-container">
            <div className="col-4">
              <h4 className="rp-pay-mobile-field">Pmt time:</h4>
            </div>
            <div className="col-8">
              <span>
                {LocaleFormating.formatDate(
                  paymentDetails.paymentDateTime,
                  'short'
                )}
              </span>
            </div>
          </div>
          <div className="row rp-pay-mobile-field-container">
            <div className="col-4">
              <h4 className="rp-pay-mobile-field">Pmt type:</h4>
            </div>
            <div className="col-8">
              <span>E-Check</span>
            </div>
          </div>
          <div className="row rp-pay-mobile-field-container">
            <div className="col-4">
              <h4 className="rp-pay-mobile-field">Pmt amount:</h4>
            </div>
            <div className="col-8">
              <span>
                {LocaleFormating.formatCurrency(paymentDetails.paymentAmount)}
              </span>
            </div>
          </div>
          <div className="row rp-pay-mobile-field-container">
            <div className="col-4">
              <h4 className="rp-pay-mobile-field">Auth code:</h4>
            </div>
            <div className="col-8">
              <span>{paymentDetails.authCode}</span>
            </div>
          </div>
          <div className="row rp-pay-mobile-field-container">
            <div className="col-4">
              <h4 className="rp-pay-mobile-field">Email:</h4>
            </div>
            <div className="col-8">
              <span>{paymentDetails.customerEmail}</span>
            </div>
          </div>
          <div className="row rp-pay-mobile-field-container">
            <div className="col-4">
              <h4 className="rp-pay-mobile-field">Database id:</h4>
            </div>
            <div className="col-8">
              <span>{paymentDetails.databaseId}</span>
            </div>
          </div>
          <div className="row rp-pay-mobile-field-container">
            <div className="col-4">
              <h4 className="rp-pay-mobile-field">Signature:</h4>
            </div>
            <div className="col-8">
              <span>{paymentDetails.signature}</span>
            </div>
          </div>
          <div className="row rp-pay-mobile-field-container">
            <div className="col-4">
              <h4 className="rp-pay-mobile-field">Ip Address:</h4>
            </div>
            <div className="col-8">
              <span>{paymentDetails.ipAddress}</span>
            </div>
          </div>
          <div className="row rp-pay-mobile-field-container">
            <div className="col-4">
              <h4 className="rp-pay-mobile-field">Status:</h4>
            </div>
            <div className="col-8">
              {paymentDetails.status === 'APPROVED' ? (
                <i className="rpds-check-circle" />
              ) : (
                <i className="rpds-error" />
              )}
              <span>{paymentDetails.status}</span>
            </div>
          </div>
          <div className="row rp-pay-mobile-field-container">
            <div className="col-4">
              <h4 className="rp-pay-mobile-field">Taker:</h4>
            </div>
            <div className="col-8">
              {paymentDetails.taker ? (
                <span>{paymentDetails.taker}</span>
              ) : (
                <input
                  className="rp-pay-mobile-input"
                  type="text"
                  value={this.state.taker}
                  onChange={this.handleChangeTaker}
                />
              )}
            </div>
          </div>
          <div className="row rp-pay-mobile-field-container">
            <div className="col-4">
              <h4 className="rp-pay-mobile-field">Note:</h4>
            </div>
            <div className="col-8">
              {paymentDetails.note ? (
                <span>{paymentDetails.note}</span>
              ) : (
                <input
                  className="rp-pay-mobile-input"
                  type="text"
                  value={this.state.note}
                  onChange={this.handleChangeNote}
                />
              )}
            </div>
          </div>
        </div>
        <div className="rp-disposition-action">
          <div className="row">
            <div className="col-12">
              <h3 className="rp-disposition-title">Pay by e-check</h3>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <span className="rp-disposition-amount">
                Total amount:{' '}
                {LocaleFormating.formatCurrency(paymentDetails.paymentAmount)}
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col-12 d-flex justify-content-center">
              <button
                className="primary-button rp-disposition-button"
                disabled={this.state.taker.length === 0}
                onClick={this.submitDisposition}
              >
                Disposition this payment
              </button>
            </div>
          </div>
          <div className="d-flex mt-10">
            <div className="print" onClick={this.printExcelEcheck}>
              <img className="image-icon xlsx-icon" src={xlsxIcon} />
            </div>
            <div className="export" onClick={this.printPdfEcheck}>
              <img className="image-icon" src={pdfIcon} />
            </div>
          </div>
        </div>
        <div className="rp-payment-details-table" />
        {paymentDetails.echeckDetails.map((invoice: any) => (
          <ECheckPaymentDetailsTableMobile invoice={invoice} />
        ))}
      </SlideMenu>
    );
  }
}

export default ECheckPaymentDetailsMobile;
